import React, { useContext } from 'react';
import StyledTitle from './StyledTitle';
import StylesContext from '../context/StylesContext';
import StyledContainer from './StyledContainer';
import LessBtn from './Buttons/LessBtn';
import MoreBtn from './Buttons/MoreBtn';
import useSessionStorage from '../hooks/useSessionStorage';

interface ButtonsChartProps {
  quantity: number;
  itemName: string;
  itemPrice: number;
}

const ButtonsChart: React.FC<ButtonsChartProps> = ({ quantity, itemName, itemPrice }) => {
  const {addItemQuantity, removeItemQuantity} = useSessionStorage();
  const {styles} = useContext(StylesContext);

  const handleMoreBtn = () => {
    addItemQuantity(itemName, itemPrice, quantity);    
  };

  const handleLessBtn = () => {
    removeItemQuantity(itemName, itemPrice, quantity);
  };

  return (
    <StyledContainer className='buttons_chart_main_container'>
      <MoreBtn color={styles.textColor} className='buttons_chart' onClickFunc={handleMoreBtn} />
      <StyledTitle $textColor={styles.btnBgColor} className='quantity_text'>
        {quantity}
      </StyledTitle>
      <LessBtn color={styles.textColor} className='buttons_chart' onClickFunc={handleLessBtn}/>
    </StyledContainer>
  )
}

export default ButtonsChart